// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__hnxaE","clinicsSelect":"TableHeading_clinicsSelect__1Y77u"};